import React, { Component } from "react";
import { Row, Col, Card, Button, Container } from "react-bootstrap";
import BreadcrumbsSection from "../breadcrumbs/BreadcrumbsSection";
import gql from "graphql-tag";
import { graphql } from "react-apollo";
import * as Cookies from "es-cookie";
import * as compose from "lodash.flowright";
import { withRouter } from "react-router-dom";
import EmployeeModal from './EmployeeModal'
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import EditEmployeeModal from './EmployeeEditModal'

const EDIT_RESTRICTIONS = gql`
  mutation($params: EmployeeRestrictions) {
    updateEmployeeRestrictions(params: $params)
  }
  `

  const DELETE_EMPLOYEE = gql`
  mutation(
    $employee_id: ID
    ) {
        deleteEmployee(
            employee_id: $employee_id
    )
  }
`;



class EmployeeRestrictionsSection extends Component {
    constructor(props) {
        super(props)
        this.state = {
            modalShow: false,
            BranchesSection: {
                Title: "Create New Employee",
                btnName: "Add Employee",
            },
            tableHeaderData: {
                Title: "Employee",
            },
            rowData: [],
            editModal: false,

            Username: "",
            password: "",
            email: "",
            contact_no: "",
            employeeType: 0,
            defaultvalue: 0,
            branch: "",


            usernameError: "",
            passwordError: "",
            emailError: "",
            contact_noError: "",
            employeeTypeError: "",
            branchError: "",

            employeeTypesOptions: [],
            collegeModulesOptions: [],

            modulesValue: [],
            qbsearchModules: [],

            subjectsValue: [],
            qbsearchSubjects: [],
            subjectOptions: [],

            selectedModulesArray: [],
            selectedModulesArrayError: "",

            dataClear: 0,

            submitError: "",
            loadingSpinner: 0,
            currentStep: 1,

            prefilledModules: [],
            finalModulesArrayPass: [],

            preSelectedSubjects: [],
            preSelectedsubjectValues: [],

            employeeId: 0
        }
    }

    articlecolumns = [
        {
            dataField: "employee_name",
            text: "Name",
            sort: true,
        },
        {
            dataField: "emp_mobile",
            text: "Mobile Number",
        },
        {
            dataField: "employee_type",
            text: "Employee Type",
        },
        {
            dataField: "branch_name",
            text: "Branch",
        },
        {
            dataField: "Edit",
            formatter: this.performanceFunc.bind(this),
            text: "Edit"
        },
        {
            dataField: "Delete",
            formatter: this.DeleteFunc.bind(this),
            text: "Delete"
        }
    ];

    componentDidMount() {

        let employeetypesArray = []
        let collegeModulesArray = []
        let subjectsArray = [];

        this.props.getEmployeeTypes.map((item) => {
            const newObj = {
                value: item.id,
                label: item.employee_type
            }
            employeetypesArray.push(newObj)
        })

        this.props.getCollegeModules.map((item) => {
            const newObj = {
                value: item.id,
                label: item.module_name
            }
            collegeModulesArray.push(newObj)
        })


        this.props.globals.offlineExamSubjects.map((item) => {
            const newObj = {
                value: item.id,
                label: item.subject
            }
            subjectsArray.push(newObj)
        })

        this.setState({ employeeTypesOptions: employeetypesArray, collegeModulesOptions: collegeModulesArray, subjectOptions: subjectsArray })
    }

    performanceFunc(cell, row, rowIndex, formatExtraData) {
        return (<>
            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.showEditModal(row)}>
                <Button variant="link" name="edit" className="text-theme">
                    <i className="far fa-edit" />
                </Button>
            </div>
        </>)
    }

    DeleteFunc(cell, row, rowIndex, formatExtraData) {

        console.log("rowrowrowrowrowrow", row)
        return (

            <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.deleteEmployee(row.employeeId)}>
                <Button variant="link" name="delete" className="text-danger"><i className="far fa-trash-alt" /></Button>
            </div>
        )
    }

    showEditModal = (data) => {
        this.setState({
            editModal: true,
            Username: data.employee_name,
            branch: data.branch_name,
            password: data.password,
            email: data.emp_email,
            contact_no: data.emp_mobile,
            preSelectedsubjectValues: data?.subject_ids?.split(','),
            employeeId: data.employeeId
        })

        let array = [];

        data.moduleAcsess.map((item, index) => {
            this.props.getCollegeModules.map((item2) => {
                if (item.module_name == item2.module_name) {
                    const newObj = {
                        value: item2.id,
                        label: item.module_name
                    }
                    array.push(newObj)
                }
            })
        })

        this.setState({
            prefilledModules: array
        })

        data.moduleAcsess.map((item) => {
            delete item.__typename
        })
        this.setState({
            finalModulesArrayPass: data.moduleAcsess
        })

        let onloadSubjects = data?.subject_ids?.split(",")

        console.log("onloadSubjects", onloadSubjects)

        let totalSubjects = this.props.globals.offlineExamSubjects

        let array3 = [];

        if (onloadSubjects != undefined) {
            totalSubjects.map((item) => {
                onloadSubjects.map((item2) => {
                    if (item.id == item2) {
                        const newObj = {
                            value: item.id,
                            label: item.subject
                        }
                        array3.push(newObj)
                    }
                })
            })
        }

        this.setState({
            preSelectedSubjects: array3
        })
    }

    deleteEmployee = async (employee_id) => {
        await this.props.deleteEmployee({
            variables:{
                employee_id
            },
            update: (store, { data }) => {
                if (data.deleteEmployee) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        })
    }

    handleInputChange = e => {
        const name = e.target.name;
        const value = e.target.value;

        var pattern = new RegExp(
            /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
        );

        if (name == "branch") {
            this.setState({ branch: value, branchError: "" })
        }
        if (name == "user_name") {
            this.setState({ Username: value, usernameError: "" })
        }
        if (name == "password") {
            this.setState({ password: value, passwordError: "" })
        }
        if (name == "email") {
            this.setState({ email: value })
            if (!pattern.test(value)) {
                this.setState({ emailError: "Please enter valid Email" })
            } else {
                this.setState({ emailError: "" })
            }
        }
        if (name == "contact_no") {
            this.setState({ contact_no: value, contact_noError: "" })
            if (value.length <= 9 || value.length > 10) {
                this.setState({ contact_noError: "Mobile number must be 10 digits" })
            } else {
                this.setState({ contact_noError: "" })
            }
        }
        if (name == "employeetype") {
            this.setState({ employeeType: value, employeeTypeError: "" })
        }
    };

    handleMultipleSelectInputChange = (e, name) => {

        if (name == "modules") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();
            let modulesArray = Array();
            let finalModulesArray = Array()

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                        enabled: false,
                    }

                    const newObj1 = {
                        label: qbtopicval.label,
                        enabled: false,
                        value: qbtopicval.value
                    }

                    const newObj2 = {
                        module_name: qbtopicval.label,
                        enabled: false,
                    }

                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                    modulesArray.push(newObj1)
                    finalModulesArray.push(newObj2)
                }
                this.setState({
                    modulesValue: qbsearchtopicvalue,
                    qbsearchModules: qbsearchtopic,
                    prefilledModules: modulesArray,
                    selectedModulesArrayError: "",
                    finalModulesArrayPass: finalModulesArray

                });
            }
        }

        if (name == "subjects") {
            let qbsearchtopic = Array();
            let qbsearchtopicvalue = Array();

            if (e != null) {
                for (let i = 0; i < e.length; i++) {
                    const qbtopicval = e[i];
                    const newObj = {
                        label: qbtopicval.label,
                        value: qbtopicval.value,
                    }
                    qbsearchtopicvalue.push(newObj);
                    qbsearchtopic.push(qbtopicval.value);
                }
                this.setState({
                    preSelectedSubjects: qbsearchtopicvalue,
                    preSelectedsubjectValues: qbsearchtopic,
                });
            }
        }
    }

    handleFormSubmit = () => {

        if (this.state.Username == "") {
            this.setState({ usernameError: "Please Enter Username", })
            return ""
        }

        if (this.state.password == "") {
            this.setState({ passwordError: "Please Enter Password", })
            return ""
        }
        if (this.state.contact_no == "" || this.state.contact_no.length > 10 || this.state.contact_no.length < 10) {
            this.setState({ contact_noError: "Please Enter valid Contact number", })
            return ""
        }

        if (this.state.email == "") {
            this.setState({ emailError: "Please Enter Email", })
            return ""
        }

        if (this.state.employeeType == 3 && this.state.preSelectedsubjectValues.length == 0) {
            this.setState({ selectedsubjectsError: "Please select Subjects" })
            return ""
        }

        if (this.state.finalModulesArrayPass.length == 0) {
            this.setState({ selectedModulesArrayError: "Please select atleast one module" })
            return ""
        }

        let params = {
            id: parseInt(this.state.employeeId),
            employee_name: this.state.Username,
            emp_mobile: this.state.contact_no,
            emp_email: this.state.email,
            password: this.state.password,
            module_access: this.state.finalModulesArrayPass,
            subject_ids: this.state.preSelectedsubjectValues.toString(),
            institute_id: parseInt(Cookies.get("institutionid")),
        }

        this.updateEmployeeRestrictions(params).catch(error => {
            this.setState({
                submitError: error.graphQLErrors.map(x => x.message)
            });
            setTimeout(() => {
            }, 5000);
        });
    }

    updateEmployeeRestrictions = async params => {
        await this.props.updateEmployeeRestrictions({
            variables: {
                params
            },
            update: (store, { data }) => {
                if (data.updateEmployeeRestrictions) {
                    this.setState({
                        loadingSpinner: 1,
                        currentStep: 5,
                    });
                    setTimeout(() => {
                        this.SetpageLoad();
                    }, 1500);
                }
            }
        });
    };

    SetpageLoad = () => {
        this.setState({ currentStep: 1, submitError: "", loadingSpinner: 0, editModal: false });
        window.location.reload(false);
    };

    render() {
        return (
            <Container>
                <Row>
                    <Col sm={12}>
                        <BreadcrumbsSection
                            onClick={() => this.setState({ modalShow: true })}
                            breadcrumbs={this.state.BranchesSection}
                        />
                    </Col>
                </Row>

                <Row className="mt-3">
                    <Col sm={12}>
                        <h5>Employee Details:-</h5>
                    </Col>
                    <Col sm={12}>
                        <CardLessDataTableWithOutSearch
                            parentData={this.props.getEmployeeDetails}
                            particlecolumns={this.articlecolumns}
                        />
                    </Col>
                </Row>
                <EmployeeModal
                    show={this.state.modalShow}
                    onHide={() => this.setState({ modalShow: false })}
                    getEmployeeTypes={this.props.getEmployeeTypes}
                    getCollegeModules={this.props.getCollegeModules}
                    globals={this.props.globals}
                />
                <EditEmployeeModal
                    show={this.state.editModal}
                    onHide={() => this.setState({ editModal: false })}
                    getEmployeeTypes={this.props.getEmployeeTypes}
                    getCollegeModules={this.props.getCollegeModules}
                    globals={this.props.globals}
                    stateData={this.state}
                    handleInputChange={this.handleInputChange}
                    handleMultipleSelectInputChange={this.handleMultipleSelectInputChange}
                    handleFormSubmit={this.handleFormSubmit}
                />
            </Container>
        )
    }

}


export default withRouter(
    compose(
        graphql(EDIT_RESTRICTIONS, {
            name: "updateEmployeeRestrictions"
        }),
        graphql(DELETE_EMPLOYEE, {
            name: "deleteEmployee"
          })
    )(EmployeeRestrictionsSection)
);